import {
    Component,
    ChangeDetectionStrategy,
    inject,
    signal,
    ViewChild,
    ElementRef,
    AfterViewChecked,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChatService } from '../data-access/chat.service';

@Component({
    selector: 'app-chat-widget',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './chat-widget.component.html',
    styleUrl: './chat-widget.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatWidgetComponent implements AfterViewChecked {
    readonly chatService = inject(ChatService);
    readonly inputText = signal('');

    @ViewChild('messageContainer') private messageContainer!: ElementRef<HTMLDivElement>;

    ngAfterViewChecked() {
        this.scrollToBottom();
    }

    onSend() {
        const text = this.inputText().trim();
        if (!text || this.chatService.isLoading()) return;
        this.inputText.set('');
        void this.chatService.sendMessage(text);
    }

    onKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.onSend();
        }
    }

    private scrollToBottom() {
        try {
            const el = this.messageContainer?.nativeElement;
            if (el) el.scrollTop = el.scrollHeight;
        } catch {}
    }
}
